import { Injectable } from '@angular/core';
import { environment } from "../../environments/environment";
declare var gtag
@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {

  constructor() { }

  setAnalyticsPageView(){
    gtag('config','GA_MEASUREMENT_ID');
  }
  setAnalyticsUserIdTracker(USER_ID: number){
    gtag('config', `${environment.codigoAnalitycs}`, {'user_id': USER_ID});
    gtag('set', 'user_properties', { 'crm_id' : USER_ID });
  }

  setAnalyticsLoginButton(evento: string){
   gtag('config',`${environment.codigoAnalitycs}`, {
      'event_category':'button', 
      'event_label': evento, 
      'value': '0'
    });
  }
  setAnalyticsSearchButton(){
    gtag('event', 'search', {
      'event_category':'busqueda', 
      // 'event_label': evento, 
      'value': '1'
    });
  }
  setAnalyticsReporteButton(){
    gtag('event', 'reporte', {
      'event_category':'reporte', 
      // 'event_label': evento, 
      'value': '2'
    });
  }
  setAnalyticsExcelButton(){
    gtag('event', 'excel', {
      'event_category':'excel', 
      // 'event_label': evento, 
      'value': '3'
    });
  }
  setAnalyticsAltaButton(){
    gtag('event', 'alta', {
      'event_category':'alta', 
      // 'event_label': evento, 
      'value': '4'
    });
  }
  setAnalyticsBajaButton(){
    gtag('event', 'baja', {
      'event_category':'baja', 
      // 'event_label': evento, 
      'value': '5'
    });
  }
  setAnalyticsModificacionButton(){
    gtag('event', 'modificacion', {
      'event_category':'modificacion', 
      // 'event_label': evento, 
      'value': '6'
    });
  }
  // setAnalyticsManualesDownload(evento: string){
  //   gtag('event', 'download', {
  //     'event_category':'manualesDownload', 
  //     // 'event_label': evento, 
  //     'value': '7'
  //   });
  // }
}

// setAnalyticsSearchButton
// setAnalyticsExcelButton;
// setAnalyticsAltaButton;
// setAnalyticsBajaButton;
// setAnalyticsModificacionButton;
 
// gtag('event', 'login', {
//   // 'event_category': <category>,
//   'event_label': nombredeusuario + ' - ' + empresa + ' - ' + perfil,
//   // 'value': <value>
// });
